import { ContractTemplateEditorDialog } from './dialogs/ContractTemplateEditorDialog'
import { EditProposalTemplateDialog } from './dialogs/EditProposalTemplateDialog'

export type DialogDataType = {
  type: string
  config: any
}

type ProposalV2DialogsProps = {
  isOpen: boolean
  closeDialog: () => void
  dialogData: DialogDataType
  proposalData: any
  fetchProjectData?: (projectId?: number) => void
}

const ProposalV2Dialogs = ({
  isOpen,
  closeDialog,
  dialogData: proposalDialogData,
  proposalData,
  fetchProjectData,
}: ProposalV2DialogsProps) => {
  if (proposalDialogData?.type === 'ContractTemplateEditor') {
    return (
      <ContractTemplateEditorDialog
        isOpen={isOpen}
        handleClose={closeDialog}
        config={proposalDialogData.config}
        proposalData={proposalData}
      />
    )
  }
  if (proposalDialogData?.type === 'EditProposalTemplate') {
    return (
      <EditProposalTemplateDialog
        isOpen={isOpen}
        handleClose={closeDialog}
        config={proposalDialogData.config}
        proposalData={proposalData}
        fetchProjectData={fetchProjectData}
      />
    )
  }
  return null
}

export default ProposalV2Dialogs
